 
 <form nz-form *ngIf="mainformGroup && fieldNew && controlExists" [nzLayout]="'vertical'" [formGroup]="mainformGroup" >
    <nz-form-item [ngStyle]="field.noFormItemMarginBottom?{'margin-bottom':'0'}:{}">
        <nz-form-label *ngIf="!field.noLabel" [nzFor]="fieldNew">{{field.label|translateTA}}</nz-form-label>
        <nz-form-control  [nzValidatingTip]="field.tooltip" nzHasFeedback>
            
                <!--[customMenuRef]="customMenu"-->
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" > </ngx-editor-menu>
                <div [style.minHeight]="(field.minRows*30)+'px'">
                    <ngx-editor
                    [editor]="editor"
                    outputFormat="html"
                    [placeholder]="field.placeholder|translateTA"
                    [formControlName]="fieldNew" 
                    ></ngx-editor>
                </div>
        </nz-form-control>
    </nz-form-item> 
    <ng-template #inputClearTpl>
        @if (mainformGroup.get(fieldNew)?.value) {
            <nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="mainformGroup.get(fieldNew).setValue(null)" />
        }
    </ng-template>
    <ng-template #formulaTpl>
        @if (field.showFormula) {
            <nz-icon nzType="thunderbolt" (click)="openFormula()"/>
        }
    </ng-template>
        <ng-template #suffixIconButton>
        @if (field.action){
            <div class="action-button-container">
                <button nz-button nzType="primary" nzSearch (click)="openComponentAction($event, field.action)" >
                    <nz-icon [nzType]="field.action.icon" />
                </button>
            </div>
        }
      
    </ng-template>
</form>